import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import LoadingScreen from '@/components/common/LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
  permissions?: string[];
  roles?: string[];
}

export default function ProtectedRoute({
  children,
  permissions,
  roles,
}: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useAuthStore();
  
  // Show loading while checking auth
  if (isLoading) {
    return <LoadingScreen />;
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Check role-based access
  if (roles && roles.length > 0) {
    if (!user?.role || !roles.includes(user.role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  
  // Check permission-based access
  if (permissions && permissions.length > 0) {
    const hasAllPermissions = permissions.every((permission) => {
      if (user?.role === 'super_admin') return true;
      return user?.permissions?.includes(permission);
    });
    
    if (!hasAllPermissions) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  
  return <>{children}</>;
}
